import { useNavigate, useLocation } from "react-router-dom";

const BackButton = ({ label = "← Retour" }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleBack = () => {
    const fromTab = location.state?.fromTab;
    if (fromTab) {
      const user = JSON.parse(localStorage.getItem("user") || "null");
      const dest = user?.role === "vendeur" ? "/dashboard" : "/client";
      navigate(dest, { state: { tab: fromTab }, replace: true });
      return;
    }

    // location.key est 'default' uniquement quand la page est le premier
    // point d'entrée dans la session React Router (lien externe, URL directe).
    // Dans ce cas navigate(-1) n'a nulle part où aller → fallback intelligent.
    if (location.key !== "default") {
      navigate(-1);
      return;
    }

    const user = JSON.parse(localStorage.getItem("user") || "null");
    if (user?.role === "vendeur") navigate("/dashboard");
    else if (user) navigate("/client");
    else navigate("/");
  };

  return (
    <button
      onClick={handleBack}
      type="button"
      aria-label="Retour"
      style={{
        display: "inline-flex", alignItems: "center", gap: "4px",
        background: "none", border: "none", color: "#e11d48",
        fontWeight: 700, fontSize: "14px", cursor: "pointer",
        padding: "12px 16px 12px 0", marginBottom: "4px",
        minHeight: "44px", touchAction: "manipulation",
      }}
    >
      {label}
    </button>
  );
};

export default BackButton;
